import { Routes, Route } from "react-router-dom";

import {
    AddInvoicesInspector,
    AuthCallback,
    Dashboard,
    EditInspectionFee,
    EditInspector,
    EditInspectorPerson,
    EditInvoicesInspector,
    EditInvoicesShipOwner,
    EditInvoiceTemplate,
    EditShipOwner,
    EditUser,
    EditVesselShipOwner,
    ForgotPassword,
    General,
    InspectionFeeList,
    InspectorList,
    InspectorPersonList,
    InvoicesInspectorList,
    InvoicesShipOwnerList,
    InvoiceTemplateList,
    NotFound,
    PaymentConfirmation,
    MultiplePaymentConfirmation,
    Profile,
    ResetPassword,
    RoleList,
    ShipOwnerList,
    Support,
    Unauthenticated,
    UserList,
    VesselShipOwnerList
} from "@/pages";
import NominationList from "@/pages/Nomination/NominationList";
import Register from "@/pages/Register";
import RegisterUser from "@/pages/RegisterUser";
import InspectorReview from "@/pages/Inspector/InspectorReview";
import ReviewShipOwner from "@/pages/ShipOwner/ReviewShipOwner";
import CompanyProfile from "@/pages/Settings/CompanyProfile";
import ReviewVesselShipOwner from "@/pages/ShipOwner/ReviewVesselShipOwner";
import ReviewInvoicesShipOwner from "@/pages/Invoices/ShipOwner/ReviewInvoicesShipOwner";
import SireReviewList from "@/pages/SireReview/SireReviewList";
import AddSireReviewRequestor from "@/pages/SireReview/AddSireReviewRequestor";
import EditSireReviewAdmin from "@/pages/SireReview/EditSireReviewAdmin";
import ReassignSireReviewAdmin from "@/pages/SireReview/Reassign/ReassignSireReviewAdmin";
import EditSireReviewReviewer from "@/pages/SireReview/EditSireReviewReviewer";
import ReopenSireReviewAdmin from "@/pages/SireReview/ReopenSireReviewAdmin";
import Logout from "@/pages/Logout";
import EditNomination from "@/pages/Nomination/EditNomination";
import InspectionProcessList from "@/pages/InspectionProcess/InspectionProcessList";
import InspectingNominationReview from "@/pages/Nomination/InspectingNominationReview";
import ShipOperatorNominationReview from "@/pages/Nomination/ShipOperatorNominationReview";
import UpdateInspectionProcess from "@/pages/InspectionProcess/UpdateInspectionProcess";
import AddInvoicesInspectorProcess from "@/pages/Invoices/Inspector/AddInvoicesInspectorProcess";
import EditPrivilege from "@/pages/Privilege/EditPrivilege";
import UserPrivilege from "@/pages/User/UserPrivilege";
import EditRole from "@/pages/Role/EditRole";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setIsAuthenticated } from "@/redux/slices/accountSlice";
import { RootState } from "@/redux/store";
import ProtectedRoute from "./ProtectedRoute";
import ReferenceDataList from "@/pages/ReferenceData/ReferenceDataList";
import EditReferenceData from "@/pages/ReferenceData/EditReferenceData";
import CancelInspectionProcess from "@/pages/InspectionProcess/CancelInspectionProcess";
import CurrencyExchange from "@/pages/CurrencyExchange/CurrencyExchange";
import AddInvoicesSireRequestor from "@/pages/Invoices/SireReviewRequestor/AddInvoicesSireRequestor";
import InvoicesSireReviewInspectorList from "@/pages/Invoices/SireReviewInspector/InvoicesSireReviewInspectorList";
import AddInvoicesSireInspector from "@/pages/Invoices/SireReviewInspector/AddInvoicesSireInspector";
import InvoicesSireReviewRequestorList from "@/pages/Invoices/SireReviewRequestor/InvoicesSireReviewRequestorList";
import InvoicesLinkedSireReviews from "@/pages/Invoices/InvoicesLinkedSireReviews";
import SireReviewPayment from "@/pages/Invoices/SireReviewPayment";
import ListInspectionResults from "@/pages/InspectionResult/ListInspectionResult";
import AddInspectionResult from "@/pages/InspectionResult/AddInspectionResult";
import InspectionStatusList from "@/pages/InspectionStatusList/InspectionStatusList";
import GroupedShipOwnerList from "@/pages/ShipOwner/GroupedShipOwnerList";
import EmailTemplates from "@/pages/Settings/EmailTemplates";
import EditEmailTemplate from "@/pages/Settings/EditEmailTemplate";
import ApplicationOptions from "@/pages/Settings/ApplicationOptions";
import EditApplicationOption from "@/pages/Settings/EditApplicationOption";
import MenuManagement from "@/pages/Settings/MenuManagement";
import EditMenuManagement from "@/pages/Settings/EditMenuManagement";
import PrivilegeManagement from "@/pages/Settings/PrivilegeManagement";
import EditPrivilegeManagement from "@/pages/Settings/EditPrivilegeManagement";
import RefDataPrivileges from "@/pages/Settings/RefDataPrivileges";
import EditRefDataPrivilege from "@/pages/Settings/EditRefDataPrivilege";
import InspectionEmails from "@/pages/Logs/InspectionEmails";
import { ROLES } from "@/common/constants";
// import ThemeToggle from "@/components/ThemeToggle";
const AppRoute = () => {
    const dispatch = useAppDispatch();
    const isAuthenticated = useAppSelector((state: RootState) => state.account.isAuthenticated);
    const menus = useAppSelector((state: RootState) => state.menu).menus;
    const roleName = useAppSelector((state: RootState) => state.account.roleName);
    const isSuperAdmin = (roleName || '').toLowerCase() === ROLES.SUPER_ADMIN;

    const handleSetIsAuthenticated = (value: boolean) => {
        dispatch(setIsAuthenticated(value));
    }

    const hasPrivilege = (url: string, parentUrl?: string) => {
        if (parentUrl){
            const parent = menus.find((menu) => menu.url === parentUrl);
            if (!parent) { return false }
            return (parent.children.findIndex((menu) => menu.url === url) >= 0);
        } else {
            return (menus.findIndex((menu) => menu.url === url) >= 0);
        }
    }

    return (
        <>
            {/* <ThemeToggle /> */}
            <Routes>
            <Route path="/" element={<Unauthenticated />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-user" element={<RegisterUser handleSetIsAuthenticated={handleSetIsAuthenticated} />} />
            <Route path="/oauth/callback" element={<AuthCallback handleSetIsAuthenticated={handleSetIsAuthenticated} />} />
            <Route path="/request-reset-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/dashboard")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <Dashboard />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspecting-company" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspecting-company")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspecting-company/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspecting-company")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspecting-company/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspecting-company")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspecting-company/review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspecting-company")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectorReview />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/grouped-list" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <GroupedShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspector" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspector")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectorPersonList />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspector/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspector")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspectorPerson />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspector/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspector")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspectorPerson />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspection-fee" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspection-fee")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectionFeeList />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspection-fee/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspection-fee")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspectionFee />
                </ProtectedRoute>
            } />
            <Route path="/manage-inspection-fee/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-inspection-fee")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInspectionFee />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <SireReviewList />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddSireReviewRequestor />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review/reopen" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReopenSireReviewAdmin />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review/edit-admin" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditSireReviewAdmin />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review/reassign" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReassignSireReviewAdmin />
                </ProtectedRoute>
            } />
            <Route path="/manage-sire-review/edit-reviewer" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditSireReviewReviewer />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-nomination")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <NominationList />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-nomination")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditNomination />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-nomination")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditNomination />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination/inspecting-review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-nomination")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectingNominationReview />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination/ship-operator-review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-nomination")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ShipOperatorNominationReview />
                </ProtectedRoute>
            } />
            <Route path="/inspection-nomination/cancel" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-process")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <CancelInspectionProcess />
                </ProtectedRoute>
            } />
            <Route path="/inspection-process" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-process")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectionProcessList />
                </ProtectedRoute>
            } />
            <Route path="/inspection-process/create-invoice" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-process")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesInspectorProcess />
                </ProtectedRoute>
            } />
            <Route path="/inspection-process/submit-result" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-process")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <UpdateInspectionProcess />
                </ProtectedRoute>
            } />
            <Route path="/inspection-process/cancel" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-process")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <CancelInspectionProcess />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-inspecting-company" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesInspectorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/inspecting-company" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesInspectorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/inspecting-company/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/inspecting-company/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoicesInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/inspecting-company/payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <PaymentConfirmation hideAmountIDR={false}/>
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/inspecting-company/multiple-payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <MultiplePaymentConfirmation />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-ship-operator" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/ship-operator" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/ship-operator/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoicesShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/ship-operator/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/'manage-invoices-ship'-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoicesShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/ship-operator/payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <PaymentConfirmation />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/ship-operator/multiple-payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <MultiplePaymentConfirmation />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/vessel" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <VesselShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/vessel/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/vessel/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReviewShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-ship-operator/vessel/review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-ship-operator")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReviewVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-vessel" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-vessel")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <VesselShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-vessel/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-vessel")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-vessel/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-vessel")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-vessel/review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-vessel")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReviewVesselShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-inspector" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspector")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesInspectorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-inspecting-company/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-inspecting-company/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-inspecting-company") || hasPrivilege("/manage-invoices/inspecting-company", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoicesInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-ship-operator" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesShipOwnerList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-ship-operator/payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <PaymentConfirmation />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-ship-operator/multiple-payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <MultiplePaymentConfirmation />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices-ship-operator/review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices-ship-operator") || hasPrivilege("/manage-invoices/ship-operator", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReviewInvoicesShipOwner />
                </ProtectedRoute>
            } />
            <Route path="/user-management/role" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/role", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <RoleList />
                </ProtectedRoute>
            } />
            <Route path="/user-management/role/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/role", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditRole />
                </ProtectedRoute>
            } />
            <Route path="/user-management/role/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/role", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditRole />
                </ProtectedRoute>
            } />
            <Route path="/user-management/users" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/users", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <UserList />
                </ProtectedRoute>
            } />
            <Route path="/user-management/users/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/users", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditUser />
                </ProtectedRoute>
            } />
            <Route path="/user-management/users/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/users", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditUser />
                </ProtectedRoute>
            } />
            <Route path="/user-management/users/privilege" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management/users", "/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <UserPrivilege />
                </ProtectedRoute>
            } />
            <Route path="/user-management/manage-privilege" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/user-management")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditPrivilege />
                </ProtectedRoute>
            } />
            <Route path="/support" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <Support />
                </ProtectedRoute>
            } />
            <Route path="/settings/general" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/general", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <General />
                </ProtectedRoute>
            } />
            <Route path="/settings/reference-data" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/reference-data", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ReferenceDataList />
                </ProtectedRoute>
            } />
            <Route path="/settings/reference-data/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/reference-data", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditReferenceData />
                </ProtectedRoute>
            } />
            <Route path="/settings/reference-data/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/reference-data", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditReferenceData />
                </ProtectedRoute>
            } />
            <Route path="/settings/email-templates" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/email-templates", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <EmailTemplates />
                </ProtectedRoute>
            } />
            <Route path="/settings/email-templates/add" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/email-templates", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <EditEmailTemplate />
                </ProtectedRoute>
            } />
            <Route path="/settings/email-templates/edit" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/email-templates", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <EditEmailTemplate />
                </ProtectedRoute>
            } />
            <Route path="/settings/application-options" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/application-options", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <ApplicationOptions />
                </ProtectedRoute>
            } />
            <Route path="/settings/application-options/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/application-options", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditApplicationOption />
                </ProtectedRoute>
            } />
            <Route path="/settings/application-options/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/application-options", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditApplicationOption />
                </ProtectedRoute>
            } />
            <Route path="/settings/menu-management" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/menu-management", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <MenuManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/menu-management/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/menu-management", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditMenuManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/menu-management/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/menu-management", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditMenuManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/privilege-management" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/privilege-management", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <PrivilegeManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/privilege-management/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/privilege-management", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditPrivilegeManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/privilege-management/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/privilege-management", "/settings") || isSuperAdmin} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditPrivilegeManagement />
                </ProtectedRoute>
            } />
            <Route path="/settings/ref-data-privileges" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/ref-data-privileges", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <RefDataPrivileges />
                </ProtectedRoute>
            } />
            <Route path="/settings/ref-data-privileges/add" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/ref-data-privileges", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <EditRefDataPrivilege />
                </ProtectedRoute>
            } />
            <Route path="/settings/ref-data-privileges/edit" element={
                <ProtectedRoute
                    isAuthenticated={isAuthenticated}
                    hasPrivilege={hasPrivilege("/settings/ref-data-privileges", "/settings") || isSuperAdmin}
                    handleSetIsAuthenticated={handleSetIsAuthenticated}
                >
                    <EditRefDataPrivilege />
                </ProtectedRoute>
            } />
            <Route path="/settings/template" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/template", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoiceTemplateList />
                </ProtectedRoute>
            } />
            <Route path="/settings/template/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/template", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoiceTemplate />
                </ProtectedRoute>
            } />
            <Route path="/settings/template/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/template", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <EditInvoiceTemplate />
                </ProtectedRoute>
            } />
            <Route path="/settings/profile" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/profile", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <Profile />
                </ProtectedRoute>
            } />
            <Route path="/settings/company-profile" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/company-profile", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <CompanyProfile />
                </ProtectedRoute>
            } />
            <Route path="/profile" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/profile")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <Profile />
                </ProtectedRoute>
            } />
            <Route path="/sire-review" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/sire-review")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <SireReviewList />
                </ProtectedRoute>
            } />
            <Route path="/settings/currency-exchange" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/settings/currency-exchange", "/settings")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <CurrencyExchange />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-inspector" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-inspector", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesSireReviewInspectorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-inspector/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-inspector", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesSireInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-inspector/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-inspector", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesSireInspector />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-requestor" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-requestor", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesSireReviewRequestorList />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-requestor/edit" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-requestor", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesSireRequestor />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-requestor/add" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-requestor", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInvoicesSireRequestor />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-inspector/reviews" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-inspector", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesLinkedSireReviews />
                </ProtectedRoute>
            } />
            <Route path="/manage-invoices/sire-requestor/reviews" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-requestor", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InvoicesLinkedSireReviews />
                </ProtectedRoute>
            } /><Route path="/manage-invoices/sire-inspector/payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-inspector", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <SireReviewPayment />
                </ProtectedRoute>
            } /><Route path="/manage-invoices/sire-requestor/payment" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/manage-invoices/sire-requestor", "/manage-invoices")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <SireReviewPayment />
                </ProtectedRoute>
            } /><Route path="/inspection-result" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-result")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <ListInspectionResults />
                </ProtectedRoute>
            } /><Route path="/inspection-result/upload" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-result")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <AddInspectionResult />
                </ProtectedRoute>
            } />
            <Route path="/inspection-status" element={
                <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={hasPrivilege("/inspection-status")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                    <InspectionStatusList />
                </ProtectedRoute>
            } />
                <Route path="/logs/inspection-emails" element={
                    <ProtectedRoute isAuthenticated={isAuthenticated} hasPrivilege={isSuperAdmin || hasPrivilege("/logs/inspection-emails", "/logs")} handleSetIsAuthenticated={handleSetIsAuthenticated}>
                        <InspectionEmails />
                    </ProtectedRoute>
                } />
            <Route path="*" element={<NotFound />} />
            </Routes>
        </>
    )
}

export default AppRoute;
